import { API_PREFIX } from './constants';

/**
 * Returns an API URL for accounting software endpoints
 * @param companyId Company ID
 * @param endpoint Accounting software endpoint
 * @param query Query string parameters
 * @returns API URL
 * @throws Error if `companyId` or `endpoint` is not provided
 * @example
 * ```
 * apiUrl('companyId', 'endpoint');
 * // => 'https://api.plooto.com/v1/companies/companyId/accountingSoftware/endpoint'
 * ```
 */
const apiUrl = (companyId: string, endpoint?: string, query?: Record<string, string>): string => {
  const cleanEndpoint = endpoint ? `/${endpoint.replace(/^\//, '')}` : '';
  const url = new URL(
    `${import.meta.env.APP_URLS_API_URL}/${API_PREFIX}` +
      `/companies/${companyId}/accountingSoftware${cleanEndpoint}`
  );

  if (query) {
    Object.entries(query).forEach(([key, value]) => {
      url.searchParams.set(key, value);
    });
  }

  return url.toString();
};

export { apiUrl };
